export default "__VITE_ASSET__DMVYf0bs__"